import React from 'react';
import { Outlet } from 'react-router-dom';
import Nav from './Nav';

const Layout = () => {
  return (
    <div className="app">
      <Nav />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
